if (!customElements.get('bundle-builder')) {
  class BundleBuilder extends HTMLElement {
    constructor() {
      super();

      this.bundleSizeMin = +this.dataset.bundleSizeMin;
      this.bundleSizeMax = +this.dataset.bundleSizeMax;
      this.bundleProducts = [];
      this.bundleProductsList = this.querySelector('[data-bundle-products-list]');
      this.addedProductsList = this.querySelector('.BundleBuilder__AddedProductsList');
      this.addedBulletsList = this.querySelector('.BundleBuilder__AddedBulletsList');
      this.addButton = this.querySelector('[data-bundle-submit]');
      this.addSubsButton = this.querySelector('[data-bundle-submit-subs]');
      this.subsOptions = this.querySelector('[data-bundle-subs-options]');
      this.subsOptionsFieldset = this.querySelector('[data-bundle-subs-fieldset]');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.subscriptionEnabled = !!this.subsOptions
      this.bundleProductsList.addEventListener('change', this.onQuantityChange.bind(this));
      this.addButton.addEventListener('click', this.addBundleToCart.bind(this));
      if (this.subsOptions) this.hideSubsOption = this.subsOptions.classList.contains('hidden');
      this.subscriptionOnly = this.getAttribute('data-subs-only');
      this.bundleInfo = this.querySelector('.BundleBuilder__Info');

      if(this.subscriptionEnabled) this.addSubsButton.addEventListener('click', this.addBundleToCart.bind(this));
    }

    onQuantityChange(e) {
      this.checkBundleQuantity();

      this.buildBundleData(e);
      this.updateProgressBar();
      this.renderBundleProducts();
      this.updatePrice();
      this.updateButtonState();
      if (this.subscriptionEnabled) this.updateSubscriptionState();
    }

    buildBundleData(e) {
      const productCard = e.target.closest('product-card');
      const productData = JSON.parse(productCard.querySelector('[data-product-data]').textContent);
      const alreadyInBundle = this.bundleProducts.find(product => product.id === productData.id) || false

      if (e.target.value > 0 && !alreadyInBundle) {
        productData.quantityInBundle = e.target.value
        this.bundleProducts.push(productData)
      } else if (e.target.value == 0 && alreadyInBundle) {
        this.bundleProducts = this.bundleProducts.filter(product => product.id !== productData.id)
      } else {
        this.bundleProducts.forEach(product => {
          if (product.id === productData.id) {
            product.quantityInBundle = e.target.value
          }
        })
      }
    }

    checkBundleQuantity() {
      this.currentBundleSize = 0
      const allQuantityInputs = this.querySelectorAll('input[name="quantity"]');
      const plusButtons = this.querySelectorAll('button[name="plus"]');

      allQuantityInputs.forEach(input => this.currentBundleSize = this.currentBundleSize + Number(input.value));

      plusButtons.forEach(btn => {
        if (this.currentBundleSize >= this.bundleSizeMax) {
          btn.classList.add('disabled');
          btn.setAttribute('disabled', '');
        } else {
          btn.classList.remove('disabled');
          btn.removeAttribute('disabled');
        }
      })

      if (this.subscriptionOnly && this.currentBundleSize === 0) {
        this.bundleInfo.classList.add('medium-down-hide');
      } else {
        this.bundleInfo.classList.remove('medium-down-hide');
      }
    }

    renderBundleProducts() {
      this.addedProductsList.innerHTML = '';
      this.bundleProducts.forEach(product => {
        this.addedProductsList.insertAdjacentHTML('beforeend', this.renderProduct(product))
      })
      this.renderBullets(this.currentBundleSize);
    }

    renderBullets(qty) {
      if (!this.addedBulletsList) return;
      const bullets = this.addedBulletsList.querySelectorAll('.BundleBuilder__AddedBullet[data-bottles]');
      for (const bullet of bullets) {
        const bottlesValue = bullet.dataset.bottles;
        if (!bottlesValue) continue;
        const bottlesCount = Number(bottlesValue);
        (bottlesCount > qty) ? bullet.classList.add('hidden') : bullet.classList.remove('hidden');
      }
    }

    renderProduct(productData) {
      const itemQuantity = productData.quantityInBundle < 10 ? '0' + productData.quantityInBundle : productData.quantityInBundle;
      let price = formatMoney(productData.price * productData.quantityInBundle, '{{amount_no_decimals}}');
      const comparePrice = formatMoney(productData.comparePrice * productData.quantityInBundle, '{{amount_no_decimals}}');
      let comparePriceHtml = productData.comparePrice > productData.price ? `<s class="price-item">${comparePrice}</s>` : '';

      if (this.subscriptionOnly === 'true') {
        comparePriceHtml = `<s class="price-item">${price}</s>`;
        price = formatMoney(productData.subscrPrice * productData.quantityInBundle, '{{amount_no_decimals}}');
      }
      return `<li class="BundleBuilder__AddedProduct">
                <span class="BundleProduct__Title">${productData.title} -</span>
                <span class="BundleProduct__Quantity">${itemQuantity}</span>
                <span class="BundleProduct__Price">${comparePriceHtml} ${price}</span>
              </li>`
    }

    updateProgressBar () {
      const currentBundleSizeElem = this.querySelector('.BundleBuilder__BottlesAdded')
      const progressBarLine = this.querySelector('.BundleBuilder__ProgressLine');
      const maxSize = this.subscriptionOnly === 'true' ? 12 : 48;

      const percentage = 100 / maxSize * this.currentBundleSize;
      if (progressBarLine) progressBarLine.style.width = percentage + '%';
      if(currentBundleSizeElem) currentBundleSizeElem.textContent = this.currentBundleSize;
    }

    updatePrice() {
      const priceElem = this.querySelector('.BundleBuilder__Price');
      const priceCompareElem = this.querySelector('.BundleBuilder__PriceCompare');
      let subtotal = 0;
      let subtotalCompare = 0;

      if (priceCompareElem) {
        this.bundleProducts.forEach(prodData => {
          subtotal = subtotal + prodData.subscrPrice * prodData.quantityInBundle
          subtotalCompare = subtotalCompare + prodData.price * prodData.quantityInBundle
        })
      } else {
        this.bundleProducts.forEach(prodData => {
          subtotal = subtotal + prodData.price * prodData.quantityInBundle
        })
      }

      if (priceCompareElem && this.subscriptionOnly === 'true') {
        subtotalCompare > 0 ? priceCompareElem.classList.remove('hidden') : priceCompareElem.classList.add('hidden');
        priceCompareElem.textContent = formatMoney(subtotalCompare, '{{amount_no_decimals}}')
      }
      priceElem.textContent = formatMoney(subtotal, '{{amount_no_decimals}}')
    }

    updateButtonState() {
      const productListBtn = this.querySelector('.BundleBuilder__ProgressInfo');
      if (this.currentBundleSize >= this.bundleSizeMin && this.currentBundleSize <= this.bundleSizeMax) {
        this.addButton.removeAttribute('disabled');
        productListBtn.classList.add('Success');
      } else {
        this.addButton.setAttribute('disabled', '');
        productListBtn.classList.remove('Success');
      }

      if (this.currentBundleSize === 0) {
        productListBtn.classList.add('Disabled')
      } else {
        productListBtn.classList.remove('Disabled')
      }
    }

    addBundleToCart(e) {
      if (this.currentBundleSize < this.bundleSizeMin || this.currentBundleSize > this.bundleSizeMax) return

      const isSubscriptionBtn = e.target.hasAttribute('data-bundle-submit-subs');
      let isRechargeBundle = !!this.querySelector('[data-rc-bundle]');
      console.log(isSubscriptionBtn)
      const finallyCallback = () => {
        this.addButton.removeAttribute('disabled');
        if (this.subscriptionEnabled) this.addSubsButton.removeAttribute('disabled');
      };
      const successCallback = (response) => {
        if (response.status) {
          const errorMessageElem = this.querySelector('.BundleBuilder__ErrorMessage');
          errorMessageElem.textContent = response.description;
          errorMessageElem.removeAttribute('hidden');
        }
      }

      this.addButton.setAttribute('disabled', '');
      if(this.subscriptionEnabled) this.addSubsButton.setAttribute('disabled', '');

      if (isRechargeBundle && isSubscriptionBtn) { // add recharge bundle to cart
        const rcBundleData = JSON.parse(this.querySelector('[data-rc-bundle]').textContent);
        const selectedSellingPlanIndex = this.subsOptionsFieldset.querySelector('input:checked').getAttribute('data-index');
        const bundleMainProductData = {
          productId: rcBundleData.rc_main_product.id,
          variantId: rcBundleData.rc_main_product.variantId,
          sellingPlan: rcBundleData.sellingPlansGroups[0].selling_plans[selectedSellingPlanIndex].id,
          handle: rcBundleData.rc_main_product.handle,
        }

        const bundleData = {
          "externalVariantId": bundleMainProductData.variantId,
          "externalProductId": bundleMainProductData.productId,
          "selections": []
        };

        this.bundleProducts.forEach((product, index) => {
          const item = {
              "collectionId": rcBundleData.collectionId,
              "externalProductId": product.id.toString(),
              "externalVariantId": product.variantId.toString(),
              "quantity": Number(product.quantityInBundle),
              "sellingPlan": product.sellingPlansGroups[0]?.selling_plans[selectedSellingPlanIndex].id
            }
          bundleData.selections.push(item);
        })

        this.getRechargeBundleData(bundleMainProductData, bundleData)
          .then((response) => {
            const dateSeconds = new Date().getSeconds();
            const bundleId = this.bundleProducts.reduce((acc, product) => {return acc + product.variantId + '-q-' + product.quantityInBundle + '|'}, '') + dateSeconds;

            response.map((item, index) => {
              item.properties._is_bundle = true
              item.properties._bundle_id = bundleId
              item.properties._quantity_in_bundle = this.bundleProducts[index].quantityInBundle
              item.properties._is_first_item_in_bundle = index === 0
              return item
            })

            const config = this.getBundleConfig(true, response);
            this.cartDrawer.fetchCart(routes.cart_add_url, config, true, successCallback, false, finallyCallback)
          })
        } else { // add custom bundle to cart
          const config = this.getBundleConfig(isSubscriptionBtn);


          this.cartDrawer.fetchCart(routes.cart_add_url, config, true, successCallback, false, finallyCallback)
        }
      }

    async getRechargeBundleData (bundleMainProductData, bundleData) {
      return await recharge.bundle.getDynamicBundleItems(bundleData, bundleMainProductData.handle);
    }

    getBundleConfig(isSubscription = false, itemsData = []) {
      const dateSeconds = new Date().getSeconds();
      const bundleId = this.bundleProducts.reduce((acc, product) => {return acc + product.variantId + '-q-' + product.quantityInBundle + '|'}, '') + dateSeconds;
      const config = fetchConfig('javascript');
      let selectedSellingPlanIndex = 0;
      if (isSubscription) selectedSellingPlanIndex = this.subsOptionsFieldset.querySelector('input:checked').getAttribute('data-index');

      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      if (!itemsData.length) {
        this.bundleProducts.forEach((product, index) => {
          const item = {
            id: product.variantId,
            quantity: product.quantityInBundle,
            selling_plan: isSubscription ? product.sellingPlansGroups[selectedSellingPlanIndex]?.selling_plans[0].id : '',
            properties: {
              "_is_bundle": "true",
              "_bundle_id": bundleId,
              "_quantity_in_bundle": product.quantityInBundle,
              "_is_first_item_in_bundle": index === 0
            }
          }
          itemsData.push(item);
        })
      }

      const body = JSON.stringify({
        items: itemsData,
        sections: this.cartDrawer.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });
      config.body = body;

      return config
    }

    updateSubscriptionState() {
      const productsNoSubscription= this.bundleProducts.filter(item => item.subscriptionAvailable === false);
      if (this.currentBundleSize >= 12 && !productsNoSubscription.length) {
        this.addSubsButton.removeAttribute('disabled');
        this.subsOptions.classList.remove('hidden');
      } else {
        this.addSubsButton.setAttribute('disabled', '');
        if (this.hideSubsOption) this.subsOptions.classList.add('hidden');
      }
    }

  }

  customElements.define('bundle-builder', BundleBuilder);
}